export default __webpack_public_path__ + "static/media/login_google.e73116c1.svg";